import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action, select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { mergeMap, switchMap, take, tap } from 'rxjs/operators';
import { AuthenticationService } from '../../services/authentication.service';
import * as routerActions from './../../../state/actions/router.actions';
import * as fromRouter from './../../../state/reducer';
import * as fromRouterSelector from './../../../state/selector/router.selector';
import { UserService } from './../../../user/services/user.service';
import * as authenticationActions from './../actions/authentication.action';

@Injectable()
export class AuthenticationEffects {
  constructor(private authenticationService: AuthenticationService, private userService: UserService,
    private actions$: Actions,
    private routerStore: Store<fromRouter.State>) {
  }

  @Effect()
  loginApplicant$: Observable<Action> = this.actions$.pipe(
    ofType(authenticationActions.LoginApplicant),
    tap(() => {
      this.routerStore.pipe(select(fromRouterSelector.selectQueryParam("return")), take(1)).subscribe(p => {
        p = p ? p : '/applicant-home';
        this.routerStore.dispatch(new routerActions.Go({ path: [p] }))
      }
      );
    }),
    switchMap(() => of(<Action>{ type: 'NO_ACTION' }))
  );

  @Effect()
  logoutApplicant$: Observable<Action> = this.actions$.pipe(
    ofType(authenticationActions.LogoutApplicant),
    mergeMap((action) =>
      this.authenticationService.logoutApplicant().pipe(
        mergeMap((data) =>
          [
            authenticationActions.LogoutApplicantSuccess(),
          ])
      )
    )
  );

  @Effect()
  loggedInApplicant$: Observable<Action> = this.actions$.pipe(
    ofType(authenticationActions.LoggedInApplicant),
    mergeMap((action) =>
      this.authenticationService.loggedInApplicant().pipe(
        mergeMap((data) =>
          [
            authenticationActions.LoggedInSuccessApplicant({ data: { applicant: data, token: action.data.token, expiresAt: action.data.expiresAt } }),
          ])
      )
    )
  );

  @Effect()
  loginUser$: Observable<Action> = this.actions$.pipe(
    ofType(authenticationActions.LoginUser),
      tap(() => {
        this.routerStore.pipe(select(fromRouterSelector.selectQueryParam("return")), take(1)).subscribe(p => {
          p = p ? p : '/user-home';
          this.routerStore.dispatch(new routerActions.Go({ path: [p] }))
        }
        );
      }),
    switchMap(() => of(<Action>{ type: 'NO_ACTION' }))
  );

  @Effect()
  logoutUser$: Observable<Action> = this.actions$.pipe(
    ofType(authenticationActions.LogoutUser),
    mergeMap((action) =>
      this.authenticationService.logoutUser().pipe(
        mergeMap((data) =>
          [
            authenticationActions.LogoutUserSuccess(),
          ])
      )
    )
  );

  @Effect()
  loggedInUser$: Observable<Action> = this.actions$.pipe(
    ofType(authenticationActions.LoggedInUser),
    mergeMap((action) =>
      this.authenticationService.loggedInUser().pipe(
        mergeMap((data) =>
          [
            authenticationActions.LoggedInSuccessUser({ data: { user: data, token: action.data.token, expiresAt: action.data.expiresAt } }),
          ])
      )
    )
  );

}


